import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    border: 'none !important',
    backgroundColor: 'transparent !important',
    color: theme.palette.themePrimary,
    minWidth: 'auto',
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    selectors: {
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        color: theme.palette.themeDarker,
      },
      '.ms-Button-label': {
        fontWeight: 'normal',
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
  noPadding: {
    selectors: {
      '&.ms-Button': {
        height: 'auto',
        padding: '0',
      },
    },
  },
});
